import axios from "axios";
// import Cookies from "js-cookie";

const CreateFarmer = async (payload) => {
  const token = JSON.parse(localStorage.getItem("authentication"));

  if (payload?.dateOfBirth === null) {
    payload.dateOfBirth = "";
  }
  if (payload?.idCardExpiryDate === null) {
    payload.idCardExpiryDate = "";
  }
  const config = {
    headers: { Authorization: `Bearer ${token}` }, 
  };

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_API}/api/farmer/CreateFarmer`, 
      payload,
      config
    );
    return data;
  } catch (error) {
    if (error.response) {
      return { status: error.response.status, payload: null };
    } else if (error.request) {
      return { status: 500, payload: null };
    } else {
      return { status: 500, payload: null };
    }
  }
};

export default CreateFarmer;
